import * as React from 'react';
import { Provider } from 'react-redux';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { uaToDeviceType } from '@cian/ui-kit/utils';
import { ErrorLogComponent } from '@cian/error-log-component';
import { TReduxStore } from '../../types/redux';
import { NewbuildingCallbackWidgetProvider } from '../NewbuildingCallbackWidgetProvider';
import { Promos } from '../Promos';
import { PurchaseContainer } from '../PurchaseContainer';
import { ContentWrapper } from '../../components/ContentWrapper';
import { ApplicationContextProvider } from '../../utils/applicationContext';
import { Carousel } from '../Carousel';
import { Header } from '../Header';
import { Projects } from '../Projects';
import { Commercial } from '../Commercial';
import { About } from '../About';
import { Mortgage } from '../Mortgage';
import { Standard } from '../Standard';
import { AdfoxPixelContainer } from '../AdfoxPixel';
import { ClustersContainer } from '../Clusters';
import { IApplicationContext } from '../../types/applicationContext';
import { OfficesContainer } from '../../components/Offices';
import { MortgageCalculator } from '../../packages/mortgage-calculator';
import { SeriaPlusContainer } from '../../components/SeriaPlus';

export interface IApplicationProps {
  reduxStore: TReduxStore;
  context: IApplicationContext;
}

export function Application(props: IApplicationProps) {
  const { reduxStore, context } = props;
  const { logger, custom } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContextProvider value={context}>
        <MicrofrontendProvider registry={context.microfrontendsRegistry}>
          <UiKitContextProvider deviceType={uaToDeviceType(custom.userAgent)}>
            <NewbuildingCallbackWidgetProvider>
              <Provider store={reduxStore}>
                <Carousel />
                <ContentWrapper>
                  <Header />
                  <Promos />
                  <SeriaPlusContainer />
                  <Projects />
                  {context.config.get<boolean>('Newbuilding.IsMortgageCalculatorV2.Enabled') ? (
                    <MortgageCalculator />
                  ) : (
                    <Mortgage />
                  )}
                  <ClustersContainer />
                  <PurchaseContainer />
                  <Standard />
                  <Commercial />
                  <OfficesContainer />
                  <About />
                  <AdfoxPixelContainer />
                </ContentWrapper>
              </Provider>
            </NewbuildingCallbackWidgetProvider>
          </UiKitContextProvider>
        </MicrofrontendProvider>
      </ApplicationContextProvider>
    </ErrorLogComponent>
  );
}
